import { render } from "./default-page.vue?vue&type=template&id=8c47de54"
import script from "./default-page.vue?vue&type=script&lang=js"
export * from "./default-page.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__